import React, { FC, useContext, useState } from 'react'

import MaxWidth from '../../layout/MaxWidth/MaxWidth'
import Menu from '../Menu/Menu'
import List from '../List/List'
import Map from '../Map/Map'

import css from './WhereToBuy.module.scss'
import cn from 'classnames'
import { WheretoBuyContext } from '../../../contexts/whereToBuyProvider'
import scrollToElement from 'scroll-to-element'
import { ImageTicker } from '../../common/ImageTicker/ImageTicker'
import AnimateHeight from 'react-animate-height'
import PlusIcon from './plus.svg'
import MinusIcon from './minus.svg'

const WhereToBuy: FC = () => {
  const {
    cities,
    loading,
    error,
    activeTab,
    setActiveTab,
    setMapCenter,
    partners,
    workHours,
  } = useContext(WheretoBuyContext)
  const [activeHours, setActiveHours] = useState<boolean>(false)

  if (loading) {
    return <>Loading...</>
  }
  if (error) {
    return <>{error.message}</>
  }
  if (!cities) {
    return null
  }

  const renderTab = () => {
    if (activeTab === 'map') {
      return <Map />
    } else {
      return <List cities={cities} />
    }
  }
  return (
    <section className={css.top_wrapper}>
      <MaxWidth>
        <div className={css.top}>
          <h1 className={css.heading}>
            Шоу-рум и пункт выдачи интернет-заказов
          </h1>
          <div className={css.contacts}>
            <address className={css.address}>
              СПб, Большая Разночинная, д.21
            </address>

            <button
              className={css.on_map}
              onClick={() => {
                setActiveTab('map')
                setMapCenter([59.970294, 30.314745])
                setTimeout(() => scrollToElement('#contacts-map'), 200)
              }}
            >
              Смотреть на карте
            </button>
            <a href="tel:+7 (962) 701-22-33" className={css.link}>
              +7 (962) 701-22-33
            </a>
            <a href="mailto:info@kmcosmetics.ru" className={css.link}>
              info@kmcosmetics.ru
            </a>
          </div>

          <dl className={css.working_hours}>
            <dt className={css.heading}>Часы работы</dt>
            <dd className={css.sheldue}>
              {workHours?.map((hour, index) => (
                <div className={css.line} key={`working-hour-${index}`}>
                  <span className={css.day}>{hour.day}</span>
                  <span className={css.hours}>{hour.hours}</span>
                </div>
              ))}
            </dd>
          </dl>

          <dl className={cn(css.working_hours, css['working_hours--mobile'])}>
            <dt>
              <button
                type="button"
                className={css.button}
                onClick={() => setActiveHours((prev) => !prev)}
              >
                {activeHours ? <MinusIcon /> : <PlusIcon />}
                <span>
                  {activeHours ? 'скрыть часы работы' : 'показать часы работы'}
                </span>
              </button>
            </dt>
            <dd>
              <AnimateHeight height={activeHours ? 'auto' : 0}>
                <div>
                  {workHours?.map((hour, index) => (
                    <div
                      className={css.line}
                      key={`working-hour-mobile-${index}`}
                    >
                      <span className={css.day}>{hour.day}</span>
                      <span className={css.hours}>{hour.hours}</span>
                    </div>
                  ))}
                </div>
              </AnimateHeight>
            </dd>
          </dl>
        </div>
      </MaxWidth>

      <ImageTicker items={partners} className={css.ticker} showMobile />

      <Menu />

      {renderTab()}
    </section>
  )
}

export default WhereToBuy
